export default __webpack_public_path__ + "images/rango-setting_029698.svg";